
import {Component, Prop, Vue, Watch} from 'vue-property-decorator';
import InstrumentList from "@/components/InstrumentList.vue"
import InstrumentSubmit from "@/components/InstrumentSubmit.vue"
import {dictApi, userApi} from "@/api/organization";
import {IPage} from "@/js/page";
import {instrumentApi} from "@/api/instrument";

@Component({
    name: "instrumentList",
    components: {InstrumentList, InstrumentSubmit}
})
export default class Home extends Vue {
  @Prop()
  propQuery: any;

  @Prop()
  tableHeight: any;

  check = "";   //1强检  0 非强检 2不区分
  showOnly = 0;  //1台账   0非台账
  region = 0;  //region  0原来的  1：按区域  2：按检测单位
  sysInstrumentAdd = false;
  sysInstrumentEdit = true;
  private closePage: any;
  form = {
    name: "",
    categoryName: "",  //对象特征
    className: "",     //测量对象
      majorName: "",   //专业大类
      addrName: "",      //器具类别
      modelSpecific: "",      //规格型号
      manufactoryName: "",      //制造单位
      useUnit: "",      //使用单位
      serialNumber: "",      //出厂编号
      productionTime: "",      //生产日期
      states: "",      //器具状态
      purposeName: "",      //器具用途
      examineNum: "",      //检定
      recordNum: "",      //备案
    warnStatus: "",  // 是否超期
    checkResult: "",  // 检定状态
    typeName: "", // 器具类型
  } as any
  categoryCodeList = [];  //对象特征
  classCodeList = [];  //测量对象
  addrCodeList = [];  //器具类别
  screenHeight = document.documentElement.clientHeight; // 可见区域高度(应为body高度，可某些环境下无法获取)
  listParam: IPage = {
    size: 10,
    current: 1,
  };
    showForm = false;
    statesList = [];   //状态
    purposeCodeList = [];  //用途
    useUnitId = "";  //使用单位id
    fullScreen = false;

    created(){
    this.getParams();
    this.haveRight();
      if(this.$route.path.indexOf('external') !== -1){
          this.fullScreen = true;
      }
  }
  //是否是本区域计量器具台账
    showStandardJudge(){
        return (this.showOnly&&this.check===''&&this.region===1);
    }
  changeInstrument(){
      //showOnly 是台账  且不区分是否是台账  且 有添加器具权限
      return (!this.showOnly&&this.check===''&&this.sysInstrumentAdd);
  }
  editInstrument(){
      //本区域台账展示编辑按钮
      //showOnly 是台账  且不区分是否是台账  且 有添加器具权限
      return (this.showOnly&&this.check===''&&this.sysInstrumentEdit);
  }

  //判断是否展示“备案状态”列
    showCheckTypeFun(){
      return true;
      // if(this.$route.params.check=='2' && this.$route.params.showOnly=='0' && this.$route.params.region=='0'){
      //     return true;
      // }
      // if(this.$route.params.check=='2' && this.$route.params.showOnly=='1' && this.$route.params.region=='1'){
      //     return true;
      // }
      // return false;
    }

  activated(){
      const $instrumentList = this.$refs.instrumentList as HTMLFormElement;
      const $instrumentSubmit = this.$refs.instrumentSubmit as HTMLFormElement;
      if (this.$route.meta && !this.$route.meta.isBack) {
          if($instrumentList){
              $instrumentList.refresh();
          }
          if($instrumentSubmit){
              $instrumentSubmit.hideForm();
              $instrumentSubmit.reset();
          }
      }else{
          if($instrumentList){
              $instrumentList.handleClick();
          }
      }
  }
    list(){
        const $instrumentList = this.$refs.instrumentList as HTMLFormElement;
        if($instrumentList) {
            $instrumentList.list();
        }
    }
    refresh(e:any) {
        this.listParam.current = 1;
        this.form = JSON.parse(JSON.stringify(e));
    }
  haveRight(){
    const right = this.$store.state.userRights;
    right.forEach((e:any)=>{
      if(e.name == "qj_add"){
        this.sysInstrumentAdd = true;
      }else if(e.name == "qj_edit"){
        this.sysInstrumentEdit = true;
      }
    })
  }
  getParams(){
      if (this.propQuery) {
        const q = this.propQuery;
        if(q.check=='2'){
          this.check = "";
        }else if(q.check=='1'){
          this.check = "2,5";
        }else if(q.check=='0'){
          this.check = "0,1,3,4";
        }else{
          this.check = q.check;
        }
        this.showOnly = Number(q.showOnly);
        this.region = Number(q.region);
        if(q.useUnitId){
          this.useUnitId = q.useUnitId as string;
        }
        if(q.size){
          this.listParam.size = Number(q.size);
          this.listParam.current = Number(q.current);
        }
        for(const f in this.form){
          if(q[f]) this.form[f] = q[f];
        }
      } else {
        if(this.$route.params.check=='2'){
          this.check = "";
        }else if(this.$route.params.check=='1'){
          this.check = "2,5";
        }else if(this.$route.params.check=='0'){
          this.check = "0,1,3,4";
        }else{
          this.check = this.$route.params.check;
        }
        this.showOnly = Number(this.$route.params.showOnly);
        this.region = Number(this.$route.params.region);
        if(this.$route.params.useUnitId){
          this.useUnitId = this.$route.params.useUnitId as string;
        }

        const route = this.$route;
        const q = JSON.parse(JSON.stringify(route.query));
        if(q.size){
          this.listParam.size = Number(q.size);
          this.listParam.current = Number(q.current);
        }
        for(const f in this.form){
          if(q[f]) this.form[f] = q[f];
        }
      }

  }
  instrumentParam(data: any){
    const route = this.$route;
    let q = JSON.parse(JSON.stringify(route.query));
    q = Object.assign(q, data);
    for (const key in q) {
      q[key] = String(q[key]);
    }
    // if(JSON.stringify(q) != JSON.stringify(route.query)){
    //   this.$router.replace({name:route.name!,query: q})
    // }
    if(q.size){
      this.listParam.size = Number(q.size);
      this.listParam.current = Number(q.current);
    }
  }
  getDict(category: number, code: string | string = ""){
    return dictApi.list({
      category: category,
      code: code
    }).then(r=>{
      if(r.data.result === 0){
        const rData = r.data.data;
        if(category == 6 && code == ""){
          this.categoryCodeList = rData;
          this.form.className = "";
          this.classCodeList = []
        }else if(category == 6 && code !== ""){
          this.classCodeList = rData;
          this.form.className = "";
        }else if(category == 3){
          this.addrCodeList = rData;
        }
        // else if(category == 1){
        //   this.typeCodeList = rData;
        //   this.form.typeCode = firstCode;
        else if(category == 2) {
            this.purposeCodeList = rData;
        }
        else if(category == 7){
          this.statesList = rData;
        }
      }
    })
  }
  //0新增 1编辑 2查看 3删除 4单个添加标准器与配套设备 5批量导入
  toDetail(type: number){
    const $instrumentList = this.$refs.instrumentList as HTMLFormElement;
    const dataArr = $instrumentList.getCheckData();
    let id = 0;
    const firstRouterText = this.$route.path.split("/")[1];
    if(type !== 0 && type !== 4 && type !== 5){
      if(dataArr.length == 0){
        this.$message.error("请先勾选器具");
        return;
      }
      if(type == 3){
        this.del(dataArr);
        return;
      }
      if(dataArr.length > 1 && type == 1){
        this.$message.error("编辑只能勾选一个器具");
        return;
      }
      if(type == 1){
        id = dataArr[0].id;
        instrumentApi.checkProgress(id).then((r: any) => {
          if(r.data.result === 0){
            const checkType = r.data.data;
            if(checkType === 2){
              this.$confirm('如对已备案的强制检定工作计量器具进行“编辑”操作，将可能导致计量器具信息发生变化，因此原备案状态无效，需重新办理备案，是否继续编辑？', '提示', {
                confirmButtonText: '是',
                cancelButtonText: '否',
                type: 'warning'
              }).then(() => {
                this.$router.push("/"+firstRouterText+"/instrument/detail/"+type+"/"+id);
              });
              return;
            }
            this.$router.push("/"+firstRouterText+"/instrument/detail/"+type+"/"+id);

          }
        });
        return;
      }
    }
    this.$router.push("/"+firstRouterText+"/instrument/detail/"+type+"/"+id);
  }
  del(dataArr: any) {
    this.$confirm('您勾选了:  ' + dataArr.length + '条器具，是否删除', '提示', {
      confirmButtonText: '确定',
      cancelButtonText: '取消',
      type: 'warning'
    }).then(() => {
      instrumentApi.delete({ids: dataArr.flatMap((e:any)=>e.id).join(",")}).then(r => {
        if (r.data.result === 0) {
          this.$message.success("删除成功");
          this.getParams();
          this.listParam.current = 1;
          const $instrumentList = this.$refs.instrumentList as HTMLFormElement;
          $instrumentList.handleClick();
        }
      })
    }).catch(() => {
      console.log("取消")
    });
  }
  // @Watch("$route.path")
  //   get$routePath(){
  //     this.getParams();
  //   }
}
